export function createProductPath (productName:string){
    return `/shop/products/${productName.toLowerCase().trim().replaceAll(" ", "-").normalize("NFD").replace(/\p{Diacritic}/gu, "").replace(/\u0142/g, "l")}`
}

export function getFirstProductImageData(product: any) {
    return product?.localImages
        ?.find((image: any) => image?.childImageSharp?.gatsbyImageData)
        ?.childImageSharp?.gatsbyImageData;
}
